import { AbstractAccessorService, IDataAccessor } from "@core/data-access";
import { IViewContentRulesRestService } from "./view-content-rules-rest";
import { IVeiwContentRuleList, IViewContentRule } from "../model/domain/ViewContentRule";
import { IResponse } from "@core/data-access/model";

// 定制面随机设计管理接口
export class ViewContentRulesRestService extends AbstractAccessorService<IViewContentRule> implements IViewContentRulesRestService {
    public $name: string = "viewContentRulesRestService";
    public static readonly $inject: string[] = ["$accessor"];
    constructor(public $accessor: IDataAccessor<IViewContentRule>) {
        super();
    }

    batchSave(data: IVeiwContentRuleList, parameters: { smvId: string; }): angular.IPromise<IResponse<boolean>> {
        return this.$accessor(this.$name, "batchSave", {
            parameter: parameters,
            data: data
        })
    }

    complete(parameters: { smvId: string; }): angular.IPromise<IResponse<boolean>> {
        return this.$accessor(this.$name, "complete", {
            parameter: parameters,
        })
    }

}